import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { interval, takeUntil, Subject, take } from 'rxjs';
import { AppData } from '@app/shared/models/appdata.model';
import { UpdateService } from '@app/core/services/update.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-version-check',
  templateUrl: './version-check.component.html',
  styleUrl: './version-check.component.scss',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class VersionCheckComponent implements OnInit, OnDestroy {
  private appData = inject(AppData);
  private updateService = inject(UpdateService);

  private checkInterval = 1000 * 60 * 5; // 5 minutes
  private destroy$ = new Subject<void>();

  currentVersion: string = this.appData.clientVersion;
  environment: string = this.appData.environment;
  hasNewVersion: boolean = false;

  ngOnInit(): void {
    this.checkVersion();

    interval(this.checkInterval)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkVersion());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private checkVersion(): void {
    this.updateService
      .getCurrentVersion()
      .pipe(take(1))
      .subscribe(version => {
        if (this.currentVersion !== version) {
          this.hasNewVersion = true;
        }
      });
  }

  forceUpdate(): void {
    window.location.reload();
  }
}
